import { render, staticRenderFns } from "./Denuncia.vue?vue&type=template&id=9ceb0e24&scoped=true&"
import script from "./Denuncia.vue?vue&type=script&lang=js&"
export * from "./Denuncia.vue?vue&type=script&lang=js&"
import style0 from "./Denuncia.vue?vue&type=style&index=0&id=9ceb0e24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ceb0e24",
  null
  
)

export default component.exports